import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { createBearerJsonClient } from '../utils/apiFetchPolicy';
import { API_URL } from '../config/env';
import brand from '../config/brand';

// Cross-domain SSO landing page. Reached on the *target* site (the sister
// origin) with a short-lived ssoToken. We exchange it for a real session token
// and drop it in this origin's localStorage, then redirect into the app.
const SsoLand = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('linking');

  useEffect(() => {
    const ssoToken = params.get('ssoToken');
    const next = params.get('next') || '/account';
    let cancelled = false;

    if (!ssoToken) {
      navigate(next, { replace: true });
      return;
    }

    const api = createBearerJsonClient(null, { baseURL: API_URL });
    api
      .post('/auth/sso/exchange', { ssoToken })
      .then((res) => {
        if (cancelled) return;
        if (res?.data?.token) {
          localStorage.setItem('authToken', res.data.token);
          if (res.data.user) {
            localStorage.setItem('authUser', JSON.stringify(res.data.user));
          }
          setStatus('done');
        } else {
          setStatus('error');
        }
        setTimeout(() => {
          if (!cancelled) navigate(next, { replace: true });
        }, 700);
      })
      .catch(() => {
        if (cancelled) return;
        setStatus('error');
        setTimeout(() => {
          if (!cancelled) navigate(next, { replace: true });
        }, 900);
      });

    return () => {
      cancelled = true;
    };
  }, [params, navigate]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'grid',
        placeItems: 'center',
        textAlign: 'center',
        padding: 24,
      }}
    >
      {status === 'linking' && <p>Signing you in to {brand.siteName}…</p>}
      {status === 'done' && <p>You are now signed in to {brand.siteName}. Redirecting…</p>}
      {status === 'error' && <p>This sign-in link has expired. Redirecting…</p>}
    </div>
  );
};

export default SsoLand;
